// extracted by mini-css-extract-plugin
module.exports = {"roomPreview":"styles_roomPreview__eXEb2","roomCrop":"styles_roomCrop__tt-ib","roomPreviewExpandIcon":"styles_roomPreviewExpandIcon__1jYe7"};